/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { AllasStandaloneFooter as ResolvedStandaloneFooter } from 'sites/allas/components/standalone/Footer';

export const Footer: typeof ResolvedStandaloneFooter = withStandaloneInstanceof((props) => {
    return (
        <ResolvedStandaloneFooter {...props} />
    );
});

export type FooterProps = PropsFromComponent<typeof Footer>;

/** @deprecated Use slot architecture instead */
export const FooterWith = (extras: DynamicStandaloneExtras): typeof Footer => {
    return function Footer(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Footer');
        return <ResolvedStandaloneFooter {...mergeProps({ options: { theme } }, props)} />;
    }
}